import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "normalize.css/normalize.css"; // cssreset
// import 'babel-polyfill';

import "./plugins/element/element.js";
import "./assets/iconfont/iconfont.css";
import "./assets/style/conmon.scss";
import Axios from "axios";
import store from "./store";
import VideoPlayer from "vue-video-player";
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
Vue.use(VideoPlayer);
// eslint-disable-next-line no-unused-vars
import * as filters from "./filters";
Vue.config.productionTip = false;
Vue.prototype.$axios = Axios;
// console.log(process.env.NODE_ENV);
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
